/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateUserPinRequestDto } from '../models/create-user-pin-request-dto';
import { UserPinDto } from '../models/user-pin-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedUserPinService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listMyUserPins
   */
  static readonly ListMyUserPinsPath = '/api/user-pins/my';

  /**
   * Lists all pins of the currently signed in user, without the actual salt.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listMyUserPins()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMyUserPins$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<UserPinDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserPinService.ListMyUserPinsPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserPinDto>>;
      })
    );
  }

  /**
   * Lists all pins of the currently signed in user, without the actual salt.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listMyUserPins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listMyUserPins(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Array<UserPinDto>> {

    return this.listMyUserPins$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<UserPinDto>>) => r.body as Array<UserPinDto>)
    );
  }

  /**
   * Path part for operation createMyUserPin
   */
  static readonly CreateMyUserPinPath = '/api/user-pins/my';

  /**
   * Creates a new pin salt for the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMyUserPin()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMyUserPin$Response(params?: {
    'X-API-Version'?: string;
    body?: CreateUserPinRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserPinDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserPinService.CreateMyUserPinPath, 'post');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserPinDto>;
      })
    );
  }

  /**
   * Creates a new pin salt for the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMyUserPin$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMyUserPin(params?: {
    'X-API-Version'?: string;
    body?: CreateUserPinRequestDto
  },
  context?: HttpContext

): Observable<UserPinDto> {

    return this.createMyUserPin$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserPinDto>) => r.body as UserPinDto)
    );
  }

  /**
   * Path part for operation getMyUserPin
   */
  static readonly GetMyUserPinPath = '/api/user-pins/my/{id}';

  /**
   * Gets the salt of a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyUserPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserPin$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UserPinDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserPinService.GetMyUserPinPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserPinDto>;
      })
    );
  }

  /**
   * Gets the salt of a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMyUserPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyUserPin(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<UserPinDto> {

    return this.getMyUserPin$Response(params,context).pipe(
      map((r: StrictHttpResponse<UserPinDto>) => r.body as UserPinDto)
    );
  }

  /**
   * Path part for operation deleteMyUserPin
   */
  static readonly DeleteMyUserPinPath = '/api/user-pins/my/{id}';

  /**
   * Deletes a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMyUserPin()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMyUserPin$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedUserPinService.DeleteMyUserPinPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Deletes a specific pin of the currently signed in user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMyUserPin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMyUserPin(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteMyUserPin$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
